import { gql, TypedDocumentNode } from '@apollo/client'
import { countryFragment } from './CountryFragment'
import type { EmployeeProfileFragment } from './__generated__/EmployeeProfileFragment'

export const employeeProfileFragment: TypedDocumentNode<EmployeeProfileFragment> = gql`
  ${countryFragment}

  fragment EmployeeProfileFragment on EmployeeProfile {
    birthdate
    buildingNumber
    city
    country {
      ...CountryFragment
    }
    countryOfBirth {
      ...CountryFragment
    }
    idCardBackPicture
    idCardExpiresOn
    idCardFrontPicture
    idCardNumber
    nationalityCountry {
      ...CountryFragment
    }
    picture
    placeOfBirth
    street
    streetNumber
    zip
  }
`
